var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvcsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M632 897h7c3-1 7-1 8-1 81 0 148-44 178-118 34-80 25-210-94-342 16-10 33-21 49-33 14-13 22-31 22-51v-85c0-12-9-22-21-22h-12v-63c0-22-14-54-50-54s-49 32-49 54v61h-19v-61c0-22-13-54-49-54s-50 32-50 54v61h-12c-12 0-21 10-21 22v86c1 26 12 50 33 68 16 13 36 22 57 25 11 2 22-6 24-18 2-11-6-22-18-24-13-2-26-8-36-16-11-9-17-23-18-36v-64h12c12 0 22-10 22-21v-83c0-1 0-11 7-11 5 0 6 7 7 11v83c0 11 9 21 21 21h61c12 0 21-10 21-21v-83c0-3 1-11 7-11 5 0 7 6 7 11v85c0 11 9 21 21 21h13v64c0 7-4 15-8 18-18 15-38 28-59 39-8 1-14 6-17 13-3 8-2 17 5 23 123 124 135 245 105 317-24 57-76 91-141 91-3 1-5 1-8 1-78 4-145-59-148-137V444c0-12-10-22-22-22h-77c-12 0-22 10-22 22v47h-68V384h167c12 0 22-10 22-21v-81c0-12-10-22-22-22H201c-12 0-21 10-21 22v571c0 12 9 22 21 22h189c11 0 21-10 21-22V673c0-12-10-21-21-21-12 0-22 9-22 21v159H222V303h224v38H279c-12 0-21 10-21 22v149c0 12 9 21 21 21h111c11 0 21-9 21-21v-47h35v253c4 100 86 179 186 179z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvcsIcon);
export default __webpack_public_path__ + "static/media/evcs_icon.ef67795672636b452e41f6f7dc89302a.svg";
export { ForwardRef as ReactComponent };